/*
 * Copyright © 2018-2021, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

export const notificationTypeHu = {
  CLINIC_DATA_EXPORT_CREATED: "Amikor egy klinika adatmentése elkészül",
  CLINIC_EMPLOYMENT_REQUEST: "Amikor egy klinikán felkérnek munkatársnak",
  CLINIC_EMPLOYMENT_REQUEST_ACCEPTED: "Amikor egy felhasználó elfogadja a meghívásodat, hogy a klinikádon dolgozzon",
  CLINIC_EMPLOYMENT_REQUEST_REJECTED: "Amikor egy felhasználó elutasítja a meghívásodat, hogy a klinikádon dolgozzon",
  CLINIC_EMPLOYMENT_REQUEST_REVOKED: "Amikor visszavonják a meghívást, hogy egy klinikán dolgozz",
  INVOICE_CREATED: "Amikor létrejön egy számla",
  INVOICE_PAYMENT_REMINDER: "Amikor egy számla fizetési határideje közeleg",
  LINKED_UNREGISTERED_PETS: "Amikor az állatom adatait rögzítik egy új klinikán",
  MEDICAL_RECORD_CREATED: "Amikor létrejön egy kórlap",
  PAYMENT_FAILED: "Amikor egy GlobalVET számlafizetés sikertelen",
  PAYMENT_SUCCEEDED: "Amikor egy GlobalVET számlafizetés sikeres",
  PET_OWNER_INVITATION: "Amikor egy gazdát meghívnak",
  PET_TRANSFER_INVITATION: "Amikor egy gazda meghív, hogy vedd át az állatát",
  PET_TRANSFER_NEW_OWNER: "Amikor egy gazda átruházza rám az állatát",
  PET_TRANSFER_OLD_OWNER: "Amikor az új gazda elfogadja az állatom átruházását",
  PET_TRANSFER_REJECTED: "Amikor egy állatátruházást elutasítanak",
  POLICY_CHANGE: "Amikor a GlobalVET felhasználási feltételei megváltoznak",
  RESERVATION_CANCELLED: "Amikor törlik a foglalásomat",
  RESERVATION_CANCELLED_BY_OWNER: "Amikor egy gazda törli a foglalását a klinikámon",
  RESERVATION_CREATED: "Amikor létrejön egy időpontfoglalás",
  RESERVATION_MODIFIED: "Amikor módosítják a foglalásomat",
  RESERVATION_REMINDER: "Amikor közeleg a foglalásom időpontja",
  TRIAL_END_REMINDER: "Amikor hamarosan lejár a próbaidőszak",
  VET_PROFESSION_APPROVED: "Amikor az állatorvosi dokumentumomat jóváhagyják",
  VET_PROFESSION_REJECTED: "Amikor az állatorvosi dokumentumomat elutasítják",

  ANNOUNCEMENT: "Közlemény",
  SYSTEM_INFORMATION: "Rendszerinformáció",
  MARKETING: "Marketing és promóció",
  CUSTOM: "Egyéb üzenetek",
};
